export const pricingPageData = {
  seoText: 'Joy is the best free wedding website and app available.',
  free: {
    title: 'Joy is free to use.',
    content: '',
  },
  revenue: {
    title: 'So how do we make money?',
    content:
      'We always knew we wanted to make Joy a free service. Weddings are expensive enough already, and we believe everyone should have access to tools to help them plan their big day! Wedding registry allows us to earn a percent commission on products sold, without ever hindering couples’ or their guests’ experience using Joy.',
  },
} as const;
